import React from 'react';
import { SEOHeader } from 'views/components';

const Reports = () => {
 
  return (
    <>
      <SEOHeader title="Reports" />    
    </>
  );
};

export default Reports;
